import { RadioSlider, RadioSliderProps } from '@almbrand/radioslider';
import classNames from 'classnames';
import { useEffect } from 'react';
import { FieldValues, UseFormRegister, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setCurrentRadioState } from 'store/slices/radioCardSlice';
import { store } from 'store/store';
import styles from './RadioSliderComponent.module.scss';

export interface RadioSliderComponentProps extends RadioSliderProps {
	register: UseFormRegister<FieldValues>;
	contentType: string;
	submitStep?: () => void;
	errorMessage?: string;
	hasError?: boolean;
	setValue?: UseFormSetValue<FieldValues>;
	trigger?: UseFormTrigger<FieldValues>;
	stepTitle?: string;
}

export const RadioSliderComponent: React.FC<RadioSliderComponentProps> = ({
	register,
	submitStep,
	name,
	contentType,
	errorMessage,
	hasError,
	setValue,
	trigger,
	...props
}) => {
	const { onChange, name: RadioSliderName } = register(name, { required: true });
	const currentRadioState = useAppSelector((state) => state.currentRadioState);
	const { displayGlobalError } = useAppSelector((state) => state.error);

	const dispatch = useAppDispatch();

	// map values
	const values = [];
	props.values.forEach((element) => {
		values.push({ [element.key]: element.value });
	});

	const getSelectedIndex = () => {
		const selectedElement = currentRadioState.find((state) => state.name === name);
		if (selectedElement) {
			return selectedElement.index;
		}
	};

	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.currentTarget;

		const selected = values.find((v) => v[Object.keys(v)[0]] === value);
		let index = -1;
		values.forEach((v, inx) => {
			if (v[Object.keys(v)[0]] === value) {
				index = inx;
			}
		});
		dispatch(setCurrentRadioState({ index, name }));
		onChange({
			target: {
				name: RadioSliderName,
				value: {
					id: name,
					value,
					index,
					label: Object.keys(selected)[0],
					type: contentType,
					stepTitle: props.stepTitle,
				},
			},
		});
		trigger(name);
		submitStep?.();
	};

	useEffect(() => {
		const value = store.getState().calculatorForm[name]?.data?.value;
		setValue(name, {
			id: name,
			value,
			type: contentType,
			stepTitle: props.stepTitle,
		});
	}, []);

	return (
		<>
			<RadioSlider
				{...props}
				className={classNames(
					styles.RadioSliderComponent,
					hasError && styles.RadioSliderComponent__errorBorder
				)}
				values={values}
				onChange={handleOnChange}
				selectedIndex={getSelectedIndex()}
			/>
			{!displayGlobalError && hasError && (
				<p
					role='alert'
					className={styles.RadioSliderComponent__error}
				>
					{errorMessage}
				</p>
			)}
		</>
	);
};
